/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Lot_History_Col_Created_ByInputs */

const vi_sl_lot_history_col_created_by = /** @type {(inputs: Sl_Lot_History_Col_Created_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người tạo`)
};

/**

* @param {Sl_Lot_History_Col_Created_ByInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_lot_history_col_created_by = /** @type {((inputs?: Sl_Lot_History_Col_Created_ByInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Lot_History_Col_Created_ByInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_lot_history_col_created_by(inputs)
});